import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

export default () => {
	const menus = document.querySelectorAll('.footer__menu-list');

	menus.forEach(function(menu) {

		const links = menu.querySelectorAll('.footer__menu-link');
		links.forEach(function(link) {
			link.addEventListener('mouseenter', (e) => {
				menu.classList.add('footer__menu-list--hover');
			});
			link.addEventListener('mouseleave', (e) => {
				menu.classList.remove('footer__menu-list--hover');
			});
		});
	});


	const footer = document.querySelector('.footer');
	const main = document.querySelector('main');

	if (footer && main) {
		const footerHeight = footer.offsetHeight;
		let tl = gsap.timeline({
			scrollTrigger: {
				trigger: main,
				start: "bottom bottom",
				end: `+=${footerHeight}`,
				scrub: true,
				// onUpdate: (self) => {
				// 	console.log(self.progress);
				// }
			}
		});

		tl.fromTo(footer, {yPercent: 40}, {yPercent: 0, duration: 1});
	}


	let cookieBtns = document.querySelectorAll('.js-open-cookies');
	cookieBtns.forEach(function(cookieBtn) {
		cookieBtn.addEventListener('click', (e) => {
			e.preventDefault();

			let appBtn = document.querySelector('.ot-floating-button__open');
			// console.log(appBtn);
			if (appBtn) {
				appBtn.click();
			}
		});
	});

};
